import React, { useState, useContext ,useEffect} from 'react';
import CancelIcon from '@material-ui/icons/Close';
import API from '../../services/api';
import TrackContext from '../../contexts/track-context';
import {ReactComponent as Play } from '../../assets/play.svg';
import {ReactComponent as Pause } from '../../assets/pause.svg';
import Amplitude from 'amplitudejs'
import Helper from '../../services/helper'
import { Link, useHistory } from 'react-router-dom';
import "./style.css";
import MewoService from '../../services/mewoService';
import Constants from '../../services/constants';
import { toast } from 'react-toastify';
import { ErrorToast, WarningToast } from '../../pure-components/CustomToast';
import { duration, ListItem } from '@material-ui/core';
import { BouncingLoader } from '../../pure-components/Loader';
import HarvestService from '../../services/harvestService';
import FormatListBulletedIcon from '@mui/icons-material/FormatListBulleted';
import MediaTile from '../Catalog/media-tile';
import defaultImage from "../../assets/default_music.png";
import PlayArrowIcon from '@mui/icons-material/PlayArrow';
import PauseIcon from '@mui/icons-material/Pause';

function AiSearch(props) {
  let trackContext = useContext(TrackContext);
  const history = useHistory();
  const {
    searchkey,
    setSearchkey,
    initialRouting,
    setinitialRouting,
    setTrackFilter
  } = trackContext;
  const [searchAI,setSearchAI]=useState(false);
  const [panel,setPanel]=useState([]);
  const [totalPanel,setTotalPanel]=useState(0);
  const [track,setTrack]=useState([]);
  const [totalTrack,setTotalTrack]=useState(0);
  const [trackCount, setTrackCount] = useState(0);

  const [loadingTracks, setLoadingTracks] = useState(false);
  const [loadingAlbums, setLoadingAlbums] = useState(false);
  const [searchText, setSearchText] = useState("");
  
   const determineTrackCount = () => {
    const width = window.innerWidth;

    if (width <= 480) {
      return 4; // Mobile
    } else if (width <= 768) {
      return 6; // Tablet
    } else {
      return 10; // Desktop
    }
  };

  useEffect(() => {
    const updateTrackCount = () => {
      setTrackCount(determineTrackCount());
    };

    // Set initial count
    updateTrackCount();

    // Update on window resize
    window.addEventListener('resize', updateTrackCount);

    // Clean up on unmount
    return () => window.removeEventListener('resize', updateTrackCount);
  }, []);

  useEffect(() => {

  },[loadingTracks, loadingAlbums])
  const getTrackList = Helper.debounce(async(e) => {
    if(e?.trim()?.length === 0)
      return;

    setSearchAI(e ? true:false); 
    setSearchkey(e); 
    
    setLoadingTracks(true);
    setLoadingAlbums(true);
    const trackfilter = {
      "SearchFilters": {
        "SearchType": "Normal",
        "IncludeInactive": "false",
        "MainOnly": "true",
        "SearchTermBundle": {
            "St_Keyword_Aggregated": {
                "ExactPhrase": "false",
                "Wildcard": "false",
                "DisableKeywordGroup": "false",
                "OrOperation": "false",
                "Keywords": e,
                "Negative": "false"
            }
        },
        "ResultView": {
            // "Sort_Predefined": "EvokeRanking",
            "View" : "Track",
            "Sort_Predefined": "RankExpression",
            "RankExpression": "-deim,-rdt,-cdc-num",
            "Evoke_PrioritizeBPM": false,
            "Evoke_SuppressVocals": false,
            "Skip": "0",
            "Limit": 10,
            include_lyrics : true
        }
      }
    };
    await loadMusicData(trackfilter).finally(() => {setLoadingTracks(false)});

    const albumfilter = {
      "SearchFilters": {
        "SearchType": "Normal",
        "IncludeInactive": "false",
        "MainOnly": "true",
        "SearchTermBundle": {
            "St_Keyword_Aggregated": {
                "ExactPhrase": "false",
                "Wildcard": "false",
                "DisableKeywordGroup": "false",
                "OrOperation": "false",
                "Keywords": e,
                "Negative": "false"
            }
        },
        "ResultView": {
            "View" : "Album",
            "Sort_Predefined": "RankExpression",
            "RankExpression": "-max(deim_album)",
            
            // "Sort_Predefined": "EvokeRanking",
            "Evoke_PrioritizeBPM": false,
            "Evoke_SuppressVocals": false,
            "Skip": "0",
            "Limit": 10
        }
      }
    };

    await loadMusicData(albumfilter, true).finally(() => {setLoadingAlbums(false)});;

  }, 800)

  const handleSearch = async()=>{
    if(searchText?.trim()?.length === 0)
        return;
    
    setSearchAI(searchText?.trim()?.length ? true:false); 
    // setSearchkey(searchText?.trim()); 
    
    setLoadingTracks(true);
    setLoadingAlbums(true);
    const trackfilter = {
      "SearchFilters": {
        "SearchType": "Normal",
        "IncludeInactive": "false",
        "MainOnly": "true",
        "SearchTermBundle": {
            "St_Keyword_Aggregated": {
                "ExactPhrase": "false",
                "Wildcard": "false",
                "DisableKeywordGroup": "false",
                "OrOperation": "false",
                "Keywords": searchText,
                "Negative": "false"
            }
        },
        "ResultView": {
            // "Sort_Predefined": "EvokeRanking",
            "View" : "Track",
            "Sort_Predefined": "RankExpression",
            "RankExpression": "-deim,-rdt,-cdc-num",
            "Evoke_PrioritizeBPM": false,
            "Evoke_SuppressVocals": false,
            "Skip": "0",
            "Limit": 10,
            include_lyrics : true
        }
      }
    };
    await loadMusicData(trackfilter).finally(() => {setLoadingTracks(false)});

    const albumfilter = {
      "SearchFilters": {
        "SearchType": "Normal",
        "IncludeInactive": "false",
        "MainOnly": "true",
        "SearchTermBundle": {
            "St_Keyword_Aggregated": {
                "ExactPhrase": "false",
                "Wildcard": "false",
                "DisableKeywordGroup": "false",
                "OrOperation": "false",
                "Keywords": searchText,
                "Negative": "false"
            }
        },
        "ResultView": {
            "View" : "Album",
            "Sort_Predefined": "RankExpression",
            "RankExpression": "-max(deim_album)",
            
            // "Sort_Predefined": "EvokeRanking",
            "Evoke_PrioritizeBPM": false,
            "Evoke_SuppressVocals": false,
            "Skip": "0",
            "Limit": 10
        }
      }
    };

    await loadMusicData(albumfilter, true).finally(() => {setLoadingAlbums(false)});;

  }
  const loadSearchedData = async(e) => {
    

    if(e.key === 'Enter' && !(loadingTracks || loadingAlbums)){
      
      await handleSearch();
    }
  }
  
  const loadMusicData = async(filter, album = false) => {

    const reqObj = {
      refUrl : `/cloudsearch/{memberToken}`, 
      method : 'post',
      headers : {
          "Accept" : "application/json",
          'Content-Type': 'application/json',
          'Cache-Control': 'no-cache',
          'Pragma': 'no-cache',
          'Expires': '0',
      },
      data : JSON.stringify(filter)
    };
    await HarvestService.loadHarvestData(reqObj).then((resp) => {
      // console.log("response data : ", resp)
      
      if(album){
        setPanel(resp?.Albums || []);
        setTotalPanel(resp?.TotalAlbums || 0);

        if(!resp?.Albums || resp?.Albums?.length === 0){
          console.warn("No album(s) found for searched query : ", searchText);
          // toast(({ closeToast }) => <WarningToast  message={"No album found for searched query."}/>);
          return;
        }
      }else{
        setTrack(resp?.Tracks || []);
        setTotalTrack(resp?.TotalTracks || 0);

        if(!resp?.Tracks || resp?.Tracks?.length === 0){
          console.warn("No track(s) found for searched query : ", searchText);
          // toast(({ closeToast }) => <WarningToast  message={"No tracks found for searched query."}/>);
          return;
        }
      }
      
      
    }).catch((err) => {
      console.log("Track List Loading Error : ", err);
      //Modify the error handling when array returned as error
      toast(({ closeToast }) => <ErrorToast  message={"Searched track list loading error."}/>);
    });
    
  }

  const playTrack = async(trackData) => {
    if (trackData.trackId === trackContext.currentTrackDetail.id && trackContext.playingFrom === props.pageId) {
      // console.log("Toggling play/pause for the same track");
      trackContext.setPlayPause(!trackContext.playPause);
      return;
    }
  
    if (Amplitude.getSongs().length) {
      // console.log("Stopping and removing the current song from Amplitude");
      Amplitude.stop();
      Amplitude.removeSong(0);
    }

    trackContext.setPlayingFrom(props.pageId)
    trackContext.setCurrentTrack(Helper.playTrackURL(trackData.trackId));
    trackContext.setCurrentTrackDetail({id : trackData.trackId, 
      display_title : trackData.title,
      description : trackData.description || "",
      duration : trackData.duration,
      bpm : trackData.bpm, 
      album : {id : trackData.albumId, name : trackData.album, image : {original : {url : Helper.getArtworkURL(trackData.albumId)}}},
      artist: trackData.artistName,
      isVersion : trackData.isVersion || false
    });
    
    const dataObj = {
      actionType : Constants.ACTION.PLAY,
      trackId : trackData.trackId,
      title : trackData.title,
      trackDesc : trackData.description || "",
      trackData : {
        albumId : trackData.albumId,
        albumName : trackData.album,
        artistName : trackData.artistName,
        duration : trackData.duration,
        bpm : trackData.bpm
      }
    } 
    await API.addPlayHistory(dataObj).then((res) => {
      if (res.success) {
        localStorage.setItem("history", JSON.stringify(res.history)); 
      } else {
        console.log("Track Adding in play history failed.", res);
      }
    }).catch(err => {
      console.log("Track Adding in play history failed.", err);
    });
  }

  const seeTrackListData = () => {
    setSearchkey(searchText?.trim()); 
    history.push(`/music/tracks/${searchText?.trim()}`)
    trackContext.setSearchResultView(Constants.SEARCH_RESULT_VIEW_TYPE.tracks);
    props.closeProjectModal();
  }
  const seeAlbumListData = () => {
    //load album list data  
    setSearchkey(searchText?.trim()); 
    history.push(`/music/albums/${searchText?.trim()}`);
    trackContext.setSearchResultView(Constants.SEARCH_RESULT_VIEW_TYPE.albums);
    props.closeProjectModal();
  }


  return (
    <div className=" w-5/6 m-10 rounded-2xl shadow-box absolute justify-center items-center z-10 bg-black/50 backdrop-blur-sm" style={{ "justifySelf" : "center", zIndex : "99" }} >
      <div className='w-full pt-4 px-6 flex justify-end'>
        <CancelIcon
          onClick={() => {props.closeProjectModal()}}
          className='text-black cursor-pointer'
          style={{ fontSize: '32px' }}
        />
      </div>

      <div className='aisearch-wrapper w-full p-4 overflow-auto'>
      
          <div className="w-full lg:px-10">
          <form onSubmit={(e) => {e.preventDefault();handleSearch()}}>
            <input
              autoFocus={true}
              onChange={event => { setSearchText(event.target.value) }}
              // onKeyDown={(e) => { loadSearchedData(e)}}
              className="placeholder-textGray-100 font-light p-2 mb-2 w-full text-2xl lg:text-2xl focus:outline-none border-b text-black bg-transparent" 
              placeholder='Search Music...'
              value={searchText}
              disabled={loadingTracks || loadingTracks}
            />
            <button type="submit" style={{ display: 'none' }}></button>
          </form>
          { !searchAI &&
          <div className="flex w-full flex-wrap">
            {/* <div className="w-full lg:w-1/5 ">
              <div className="font-normal text-base">Search  by:</div>
            </div> */}
            {/* <div className="w-full mt-3 lg:mt-0 lg:w-2/5 pr-2">
              <div className="font-semibold text-base">URL</div>
              <div className="text-sm text-textGray-100">Copy and paste a URL from a YouTube or Vimeo video here and our A.I. Search kicks into action to list the best matched tracks in our music!</div>

            </div> */}
            <div className="w-full mt-3 lg:mt-0 pr-2 album-label">
              <div><span className="t-title">Keyword </span> (Press "⏎" to Search)</div>
              <div className="t-artist">Enter a keyword to search by Track Title or by Album Name</div>

            </div>
          </div>
          }
           { searchAI && 
           <>
           <div className="w-full pb-4">
           <div className="album-label">Search result for "{searchkey}"</div>
            </div>
            <div className="flex flex-wrap">
            <div className="w-full  sm:w-2/4 pr-2 ">
              <div className='w-full flex'>
                <div className="w-8/12 justify-start album-label text-base">Tracks ({loadingTracks ? 0 : totalTrack || 0})</div>
                <div className='w-4/12'>
                  {totalTrack > 0 &&( 
                    <div className="w-full flex justify-end pr-6 t-desc cursor-pointer"
                    onClick={seeTrackListData} >
                      <span className='flex justify-end'>
                        <FormatListBulletedIcon
                          className="trackicon w-8  sm:w-6 sm:mb-4 sm:mt-5 right-2 self-center cursor-pointer"
                          style={{ fontSize: "16px", marginRight: "2px"}}
                        />
                        View All
                      </span>
                    </div>
                  )}
                </div>
              </div>
              <div className="album-wrapper sm:overflow-y-auto">
                {loadingTracks ?  
                  <div className='w-full'>
                    <BouncingLoader />
                  </div>
                :
                <>{track?.length === 0 ?
                  
                <div className="text-sm text-center text-red-500 my-5">
                  No Track(s) Found
                </div> : 
                <>
                {track?.map(item=>{
                  return <div className="flex rouded-2xl border-b"> <div className='self-center play-button'>
                  {/* <div
                    aria-label="play/pause"
                    className='outline-none focus:outline-none play-button border-symStrokeGrey cursor-pointer'
                   onClick={() => playTrack({
                    trackId : item.ID,
                    title : item.DisplayTitle,
                    description : item.Comment,
                    duration : item.LengthSeconds,
                    bpm : item.Bpm,
                    albumId : item.AlbumID,
                    album : item.AlbumTitle,
                    artistName : item.Artist
                   })}
                  >
                    {                  
                  (trackContext.playPause && item.ID === trackContext.currentTrackDetail.id) ? 
                   <Pause className='outline-none' />
                        :
                        <Play className='outline-none' />
                    }
                  </div> */}

                  <button
                    aria-label="Play or Pause"
                    className="p-3 rounded-full border border-gray-400 shadow-sm flex items-center justify-center"
                    onClick={() => playTrack({
                      trackId : item.ID,
                      title : item.DisplayTitle,
                      description : item.Comment,
                      duration : item.LengthSeconds,
                      bpm : item.Bpm,
                      albumId : item.AlbumID,
                      album : item.AlbumTitle,
                      artistName : item.Artist
                    })}
                    style={{background: "rgb(var(--pink))", color: "rgb(var(--text))"}}
                  >
                    {trackContext.playPause &&
                      item.ID === trackContext.currentTrackDetail.id ? (
                      <PauseIcon 
                        style={{color: "rgb(var(--bg))", height:"38px", width:"38px"}}/>
                    ) : (
                      <PlayArrowIcon style={{color: "rgb(var(--bg))", height:"38px", width:"38px"}}/>
                    )}
                  </button>
                </div>
                <div className='w-5/6 self-center p-2'>
                  <h1 className='t-title text-base capitalize' > {item.DisplayTitle?.toLowerCase()}</h1>
                  <h2 className='t-artist capitalize'>{item.LibraryName?.toLowerCase()} </h2>
                </div>
                <div className='w-1/6 text-center p-2'>
                    <span className='t-desc'>{item.LengthSeconds &&
                      new Date(item.LengthSeconds * 1000).toISOString().substr(14, 5)}
                    </span>
                </div>
                </div>
                })}
                </>
                }
                </>
                }
              </div>
              {/* {totalTrack > 0 &&
                ( 
                  <div className="w-1/2 text-center font-normal text-sm pb-4 cursor-pointer see-tracks"
                  onClick={seeTrackListData} ><span className='showborder'>See Tracks List</span></div>
                )} */}
            </div>
            
            <div className="w-full sm:w-2/4 pr-2 " >
              <div className='w-full flex'>
                <div className="w-8/12 justify-start album-label text-base pb-4">Albums ({loadingAlbums ? 0 : totalPanel || 0})</div>
                <div className='w-4/12'>
                  {totalPanel > 0 &&( 
                    <div className="w-full flex justify-end pr-6 t-desc cursor-pointer"
                    onClick={seeAlbumListData} >
                      <span className='flex justify-end'>
                        <FormatListBulletedIcon
                          className="trackicon w-8  sm:w-6 sm:mb-4 sm:mt-5 right-2 self-center cursor-pointer"
                          style={{ fontSize: "16px", marginRight: "2px"}}
                        />
                        View All
                      </span>
                    </div>
                  )}
                </div>
              </div>
              <div className='album-wrapper lg:overflow-y-auto'>
                {loadingAlbums ? 
                  <div className='w-full'>
                    <BouncingLoader />
                  </div>
                :
                <>
                {panel?.length === 0 ? 
                <div className="text-sm text-center text-red-500 my-5">
                  No Album(s) Found
                </div> :
                <>
                <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-2 sm:gap-2 md:gap-2 mt-2 grid-rows-[auto_1fr_auto]">
                  {panel?.map(item=>{
                      return <div className="flex mb-3">
                    {/* <div className='w-20 h-20  overflow-hidden'>
                      <Link className="self-center" to={`/album/${item.ID}`}  >
                      <img src={Helper.getArtworkURL(item.ID)} className="cursor-pointer" width='100%' alt='album art' onError={(e)=>trackContext.setDefaultImage(e)}/>
                      </Link>
                    </div>
                    <div className='w-4/6 px-2'>
                      <h1 className='track-title-old sm:text-base mr-2 capitalize' > {item.Name?.toLowerCase()}</h1>
                      <h2 className='text-xs text-textGray-100 capitalize'>{item.LibraryName?.toLowerCase()} </h2>
                    </div> */}
                      <Link className="self-center" to={`/album/${item.ID}`}  >
                        <MediaTile
                          style={{ backgroundColor: "rgb(var(--bg))", color: "rgb(var(--text))" }}
                          image={Helper.getArtworkURL(item?.ID) || defaultImage}
                          title={item.Name?.toLowerCase()}
                          code=""
                          description={item.LibraryName?.toLowerCase()}
                          id={item.ID}
                        />
                      </Link>
                      
                    </div>
                    })}
                  </div>
                  </>
                  }
                  </>
                }
                </div>
                {/* {totalPanel> 0 &&(
                  <div className="w-1/2 text-center font-normal text-sm pb-4 cursor-pointer see-tracks"
                  onClick={seeAlbumListData} > <span className='showborder'>See Albums List</span></div>
                )} */}
              </div>
            </div>
           </>
          } 
        </div>
    
      {/* {
        searchAI &&
        <div className='w-full px-10 py-10' >
          <input
            autoFocus={true}
            onChange={(e) => { getTrackList(e.target.value) }}
            onKeyDown={setAISearch}
            className='p-2 mb-2 w-6/12 text-lg focus:outline-none border-b text-black bg-transparent'
            placeholder='Search Music...'
          />
         </div> 
      } */}
      </div>
    </div>
  )
}

export default AiSearch;